import gql from 'graphql-tag'
import assign from 'lodash/assign'
import clone from 'lodash/clone'
import base from 'app/queries/base'

export default {

    all: function(options={}){

        return assign(clone(base), {

            query: gql`
                query AllProjects($offset: Int, $limit: Int, $filter: ProjectFilter, $sortField: ProjectSortField, $sortDirection: SortDirection, $search: String) {
                    viewer {
                        allProjects(offset: $offset, limit: $limit, filter: $filter, sortField: $sortField, sortDirection: $sortDirection, search: $search) {
                            totalCount
                            items {
                                id
                                title
                                code
                                startDate
                                endDate
                                projectManager
                                locationTitle
                                locationManual
                                address
                                postalCode
                                city
                                country
                                locationLat
                                locationLng
                                loggerDailyPriceMultiplier
                                loggerUsagePriceMultiplier
                                loggerBackofficePriceMultiplier
                                loggerFailurePriceMultiplier
                                loggerManualRoundPriceMultiplier
                                createdAt
                                updatedAt
                            }
                        }
                    }
                }`,

            variables(){

                return {
                    offset: null,
                    limit: null,
                    filter: {},
                    search: null
                }
            },

            update: ({viewer}) => viewer.allProjects

        }, options);
    },

    allCodes: function(options={}){

        return assign(clone(base), {

            query: gql`
                query AllProjectCodes($offset: Int, $limit: Int, $filter: ProjectFilter, $sortField: ProjectSortField, $sortDirection: SortDirection, $search: String) {
                    viewer {
                        allProjects(offset: $offset, limit: $limit, filter: $filter, sortField: $sortField, sortDirection: $sortDirection, search: $search) {
                            totalCount
                            items {
                                id
                                code
                            }
                        }
                    }
                }`,

            variables(){

                return {
                    offset: null,
                    limit: null,
                    filter: {},
                    search: null
                }
            },

            update: ({viewer}) => viewer.allProjects

        }, options);
    },

    find: function(options={}){

        return assign(clone(base), {

            query: gql`
                query FindProject($projectId: ID!) {
                    viewer {
                        findProject(id: $projectId) {
                            id
                            title
                            code
                            startDate
                            endDate
                            projectManager
                            locationTitle
                            locationManual
                            address
                            postalCode
                            city
                            country
                            locationLat
                            locationLng
                            loggerDailyPriceMultiplier
                            loggerUsagePriceMultiplier
                            loggerBackofficePriceMultiplier
                            loggerFailurePriceMultiplier
                            loggerManualRoundPriceMultiplier
                            actionDeadline
                            munisenseGroupId
                            createdAt
                            updatedAt
                        }
                    }
                }`,

            update: ({viewer}) => viewer.findProject

        }, options);
    }
}